module.exports = __webpack_public_path__ + "static/img/banner2_bg@2x.a9ebb353.png";